/*
 * File: PageSubHeader.tsx
 * Project: rosita
 * -----
 * Last Modified: 18 Feb 2022 4:38:40 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { Col, Menu, Row, Space, Typography } from 'antd';
import { CompanySelect } from 'components/atoms/CompanySelect';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAppSelector } from 'redux/store';
import { InlineStylesModel } from '../../models/InlineStylesModel';

const styles: InlineStylesModel = {
  row: {
    backgroundColor: '#181823',
    // padding: '0px 50px',
    color: '#84859a',
    fontSize: '1rem',
    height: 46
  },
  menuContainer: {
    height: '100%'
  },
  largeContainer: {
    width: 430
  },
  row2: {
    margin: '0 auto',
    maxWidth: '1920px',
    flex: '1 1 0%',
    alignItems: 'center',
    flexDirection: 'row',
    rowGap: '16px',
    padding: '0 50px'
    // padding: window.innerWidth > 2000 ? '0 50px' : 0
  }
};

export const PageSubHeader = (): JSX.Element => {
  const { pathname } = useLocation();

  const cookie = Cookies.get(`${process.env.REACT_APP_COOKIE_PREFIX}_acuity_context`);
  const { user, company, acuityContext } = useAppSelector((state) => state.app);
  const isMdsiEmployee = user ? user['https://acuity.mdsiinc.com/user/user_metadata'].is_mdsi_employee : null;

  const divisionId = pathname.split('/')[1];

  const isHome = pathname.includes('internal');

  const cookieCompany = `${acuityContext?.selectedCustomer.name}-${acuityContext?.selectedCustomer.erpId}`;

  const [selectedMenu, setSelectedMenu] = useState<string>('search');
  const isView = pathname.includes('/projects');
  const isRecover = pathname.includes('/recover');

  const featureMenuJSX = (
    <Menu disabledOverflow={true} mode="horizontal" theme="dark" style={styles.smallContainer} activeKey={selectedMenu} defaultSelectedKeys={[selectedMenu]} selectedKeys={[selectedMenu]}>
      {isMdsiEmployee && (
        <Menu.Item key="search">
          <Link to="/internal">Customers</Link>
        </Menu.Item>
      )}
      {isView && (
        <Menu.Item key="details">
          <Link to={`/${divisionId}/projects`}>Details</Link>
        </Menu.Item>
      )}
      {isView && (
        <Menu.Item key="create">
          <Link to={`/${divisionId}/projects/create`}>Create</Link>
        </Menu.Item>
      )}
    </Menu>
  );

  useEffect(() => {
    if (!pathname.includes('/customers')) setSelectedMenu('search');
    if (pathname.includes('/projects')) setSelectedMenu('details');
    if (pathname.includes('/create')) setSelectedMenu('create');
  }, [pathname]);

  return (
    <Row style={styles.row} justify="center" align="middle">
      <Row style={styles.row2} justify="space-between" align="middle">
        <Col>
          <Space size="large">
            {isMdsiEmployee && <CompanySelect />}
            {!isHome && (
              <Typography.Title level={5} style={{ color: 'rgb(132, 133, 154)', margin: 0 }}>
                {company ? company : cookieCompany ? cookieCompany : ''}
              </Typography.Title>
            )}
          </Space>
        </Col>
        {!isRecover && <Col>{featureMenuJSX}</Col>}
      </Row>
    </Row>
  );
};
